export default __webpack_public_path__ + "images/dbff118d9fb34915162677890195f592-fineart.jpg";